import { render, staticRenderFns } from "./orgType.vue?vue&type=template&id=7121e5af&"
import script from "./orgType.vue?vue&type=script&lang=js&"
export * from "./orgType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports